export const IconWhiteBasketDelete12: {
  name: 'icon_white_basket_delete_12-e74f3ebf9bd8'
} = {
  name: 'icon_white_basket_delete_12-e74f3ebf9bd8'
}
